'use strict';

module.exports = [ 'datasource', 'form', 'integration', 'actionFields', function (datasource, form, integration, actionFields) {
    var _this = this;
    _this.datasource = datasource;
    if (_this.datasource.filters == undefined)
        _this.datasource.filters = []
    _this.form = form;
    _this.integration = integration;
    _this.actionFields = actionFields;

    _this.isIntegrationSource = () => {
        if (_this.actionFields || !_this.integration) return false;
        if (_this.datasource.type === "integration") return true;
        if (_this.datasource.type === "distinct" && _this.datasource.integrationId) return true;
        return !_this.form;
    };

    _this.filterSourceName = () => {
        if (_this.isIntegrationSource()) {
            return (_this.integration && _this.integration.name) || "";
        }
        return (_this.form && _this.form.name) || "";
    };

    this.validOperations = ["=", "!=", "<", ">", "<=", ">=", "existe", "!existe"];
    this.removeBlock = function (scope) {
        scope.remove();
    };

    this.removeCondition = function (index) {
        _this.datasource.filters.splice(index, 1);
    };
    this.addCondition = function (conditions) {
        if (_this.datasource.filters) {
            _this.datasource.filters.push({
                conditions: [
                    {
                        type: "field",
                        fieldId: "",
                        fieldParentId: undefined,
                        value: "",
                        operator: "" //>,< ,>= >=, !=
                    }
                ],
                options: []
            });
        } else {
            _this.datasource.filters = [
                {
                    conditions: [
                        {
                            type: "field",
                            fieldId: "",
                            fieldParentId: undefined,
                            value: "",
                            operator: "" //>,< ,>= >=, !=
                        }
                    ],
                    options: []
                }
            ];
        }
    };

    this.addBlock = function (operator, list) {
        switch (operator) {
            case "or":
                list.push({
                    type: "operator",
                    operator: "or",
                    rules: []
                });
                break;
            case "and":
                list.push({
                    type: "operator",
                    operator: "and",
                    rules: []
                });
                break;
            case "field":
                list.push({
                    type: "field",
                    fieldId: "",
                    value: "",
                    operator: "" //>,< ,>= >=, !=
                });
                break;
            default:
                break;
        }
    };

    this.areValid = function (conditions) {
        var invalid = conditions.filter(function (con) {
            return !con.valid;
        });

        if (invalid) {
            return false;
        } else {
            return true;
        }
    };

    this.close = function () {
        _this.$close(_this.datasource);
    };
}]